import React from "react";

function SurveyForm({ schema, object, onChange }) {
  return (
    <>
      {Object.entries(schema.fields).map(([field, config]) => {
        return (
          <div className="col-12" key={field}>
            <label className="form-label fw-semibold">{config.label}</label>

            {config.type === "text" && (
              <input
                type="text"
                className="form-control"
                value={object[field] || ""}
                onChange={(e) => onChange(e.target.value, field)}
                required
              />
            )}

            {config.type === "multipleChoice" && (
              <div className="d-flex flex-column gap-1">
                {config.options.map((opt, idx) => (
                  <label key={idx} className="form-check-label">
                    <input
                      type="radio"
                      name={field}
                      value={opt}
                      className="form-check-input me-2"
                      checked={object[field] === opt}
                      onChange={() => onChange(opt, field)}
                      required
                    />
                    {opt}
                  </label>
                ))}
              </div>
            )}

            {config.type === "scale" && (
              <div className="d-flex gap-3 mt-2">
                {Array.from({ length: 10 }, (_, i) => i + 1).map((num) => (
                  <label key={num}>
                    <input
                      type="radio"
                      name={field}
                      value={num}
                      checked={object[field] === String(num)}
                      onChange={() => onChange(String(num), field)}
                      required
                    />{" "}
                    {num}
                  </label>
                ))}
              </div>
            )}
          </div>
        );
      })}
    </>
  );
}

export default SurveyForm;
